import React, { useContext, useState } from "react";
import { PersonalData, LearningPath, Extras } from "./components";
import { useLocation, useHistory } from "react-router-dom";
import { Loader } from "../../components";
import { EndPoints } from "../../api/index";
import axios from "axios";
import { AlertContext } from "../../context/context";
import PaymentSuccess from "./components/paymentSuccess/paymentSuccess";

const Home = () => {
  const { setAlertState } = useContext(AlertContext);
  const { hash } = useLocation();
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    personal: {},
    education: {},
    others: {},
    extras: {},
  });
  let validInfo = false;
  const handleNextForm = (key, values) => {
    setFormData({ ...formData, [key]: { ...formData[key], ...values } });
  };

  const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  const waitHandler = async (waitArg) => {
    const { seconds, completed } = waitArg;
    if (!completed) {
      await sleep(seconds);
      return waitHandler(waitArg);
    }
    return () => true;
  };

  const submitData = async (e, hasCoupon) => {
    const { personal, others, extras } = formData;
    const personalDataToSave = { ...personal };
    const dataToValidate = {
      ...personalDataToSave,
      others: others,
      coupon: hasCoupon ? extras.coupon : "",
      transaction_id: "true",
      ...extras,
      ...e,
    };

    setLoading(true);

    try {
      const validateRes = await axios.post(
        EndPoints.validateUser,
        dataToValidate
      );

      if (validateRes.status) {
        setLoading(false);
        validInfo = true;
      }
    } catch (err) {
      setLoading(false);
      setAlertState({
        show: true,
        status: "Failure",
        labelText: err?.response?.data?.message,
        type: "Information validation",
        failure: true,
      });
    }

    if (hasCoupon && validInfo) {
      try {
        const res = await axios.post(EndPoints.apply, dataToValidate);

        if (res.data.success) {
          sessionStorage.setItem(
            "paySuccess",
            JSON.stringify({
              show: true,
              labelText:
                "Thanks, your payment was successful. Check email for instructions",
              failure: false,
              status: "Success",
              type: "Application payment",
            })
          );
          const { payment_data } = res.data?.data;
          if (payment_data) {
            window.location.href = payment_data.paymentUrl;
          } else {
            history.push("/");
          }
          setLoading(false);
        }
      } catch (err) {
        setLoading(false);
        setAlertState({
          show: true,
          status: "Failure",
          labelText: err?.response?.data?.message,
          type: "Application Payment",
          failure: true,
        });

        setFormData({ ...formData, extras: { coupon: "" } });
      }
    } else if (validInfo && !hasCoupon) {
      try {
        const dataToSubmit = {
          ...personalDataToSave,
          others: others,
          transaction_id: "true",
          coupon: " ",
          ...extras,
          ...e,
        };
        const res = await axios.post(EndPoints.apply, dataToSubmit);
        if (res?.data?.success) {
          setLoading(false);

          // const { authorization_url } = res.data?.data?.payment_data;
          // window.location.href = authorization_url;
          const { paymentUrl } = res.data?.data?.payment_data;
          window.location.href = paymentUrl;
          sessionStorage.setItem(
            "paySuccess",
            JSON.stringify({
              show: true,
              labelText:
                "Thanks, your payment was successful. Check email for instructions",
              failure: false,
              status: "Success",
              type: "Application payment",
            })
          );
        }
      } catch (err) {
        setLoading(false);
        setAlertState({
          show: true,
          status: "Failure",
          labelText: err?.response?.data?.message,
          type: "Application Payment",
          failure: true,
        });
      }
    } else {
      console.log("-");
    }
  };

  const DisplayComponents = () => {
    const [baseHash, queryString] = hash.split("?");
    switch (baseHash) {
      case "#learning":
        return (
          <LearningPath formData={formData.others} onNext={handleNextForm} />
        );
      case "#extras":
        return (
          <Extras
            formData={formData.extras}
            onNext={handleNextForm}
            onSubmit={submitData}
          />
        );
      case "#payment-success":
        return <PaymentSuccess />;
      default:
        return (
          <PersonalData formData={formData.personal} onNext={handleNextForm} />
        );
    }
  };
  return (
    <>
      {loading ? <Loader /> : ""}
      <DisplayComponents />
    </>
  );
};

export { Home };
